import { StrategyAutomationsModalWrapper } from './style';
import StrategyAutomations, { IStrategyAutomationsProps } from './index';
import CloseTabButton from 'crono-fe-common/components/CronoButton/closeTabButton';
import { useStrategyAutomations } from '../../strategyAutomations';

export const StrategyAutomationsModalWidth = 410;

type IProps = IStrategyAutomationsProps;

const StrategyAutomationsModal = (props: IProps) => {
  const { setStrategyCardRandomIdForOpenedAutomations } =
    useStrategyAutomations();

  const close = () => {
    setStrategyCardRandomIdForOpenedAutomations(null);
  };

  return (
    <StrategyAutomationsModalWrapper
      style={{ width: StrategyAutomationsModalWidth }}
    >
      <div className="modal-cross">
        <CloseTabButton close={close} />
      </div>
      {/**
       * IMPORTANT: IF WE EVER REMOVE THE DISABLE EDIT FROM HERE NOTE THAT THE EDIT MODAL OF THE STRATEGY AUTOMATIONS HAS ISSUES WITH THE SELECTS CLOSING IT WHEN OPENING THEM
       */}
      <StrategyAutomations {...props} disableEdit />
    </StrategyAutomationsModalWrapper>
  );
};

export default StrategyAutomationsModal;
